import type { InterfaceTableMeta } from '../../app'

// AI draft in peninsular Spanish (Madrid, "tú"), pending native review
// (ADR-111, translation provenance). Change to 'native-reviewed' only when a
// native speaker has reviewed the whole table.
export const meta: InterfaceTableMeta = { review: 'ai-draft' }
